import "./Footer.scss";

const Footer = () => {
    return (
        <footer className="site-footer">
            Products table project | Sukhrob Sanhinov
        </footer>
    );
};

export default Footer;
